import { configureStore } from '@reduxjs/toolkit';
import centerReducer from './slices/centerSlice';
import centersListReducer from './slices/centersListSlice';
import authReducer from './slices/authSlice';
import classReducer from './slices/classSlice';

export const store = configureStore({
  reducer: {
    center: centerReducer,
    centersList: centersListReducer,
    auth: authReducer,
    class: classReducer,
  },
});

export default store;
